import { render, staticRenderFns } from "./content-question.vue?vue&type=template&id=230b7281"
import script from "./content-question.vue?vue&type=script&lang=js"
export * from "./content-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports